import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import axios from 'axios';
import { adminAPIURL } from '../../../../../../../../Config';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CAR_TYPE, GET_CAR_TYPE_EMPTY, POST_IMAGE, POST_IMAGE_EMPTY } from '../../../../../../../../../store/actions';
import { isValidEmail } from '../../../../../../../../Helpers/Helpers';
import cogoToast from 'cogo-toast';
import AddCarType from '../Modal/AddCarType';
import { Error, Loader } from '../../../../../../../../Common';
import { FiUpload } from 'react-icons/fi';
import { Trash2 } from 'react-feather';

const currencyOptions = [
  { label: 'INR', value: 'INR' },
  { label: 'AED', value: 'AED' },
  { label: 'Dollar', value: 'Dollar' },
  { label: 'Euro', value: 'Euro' },
];

const AddVendor = ({
  vendor,
  setVendor,
  errors,
  setErrors,
  state,
  isVendorFullConfigure,
  isUpdate = false,
  existCarTypeOptionsForUpdate = [],
  car,
  setCar,
}) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [carErrors, setCarErrors] = useState<any>([{}]);
  const [loading, setLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [carTypeList, setCarTypeList] = useState([]);
  const [carTypeOptions, setCarTypeOptions] = useState([]);
  const [isShowCarTypeModal, setIsShowCarTypeModal] = useState(false);

  const { getCarType, getCarTypeLoading, createUploadTicket } = useSelector((state: any) => ({
    getCarType: state.GetCarType.data,
    getCarTypeLoading: state.GetCarType.loading,

    createUploadTicket: state?.PostImage?.data,
  }));

  // Enable all fields except email if updating
  useEffect(() => {
    if (isUpdate) {
      setIsEditable(true);
    }
  }, [isUpdate]);

  useEffect(() => {
    if (createUploadTicket !== null) {
      setVendor(vendor => ({ ...vendor, documentUrl: createUploadTicket?.data }));
      setErrors(prev => ({ ...prev, documentUrl: '' }));
      dispatch({ type: POST_IMAGE_EMPTY });
    }
  }, [createUploadTicket]);

  useEffect(() => {
    dispatch({ type: GET_CAR_TYPE });
  }, []);

  useEffect(() => {
    if (getCarType !== null) {
      setCarTypeList(getCarType?.data ?? []);
      dispatch({ type: GET_CAR_TYPE_EMPTY });
    }
  }, [getCarType]);

  useEffect(() => {
    if (vendor?.selectedCarTypes?.length > 0) {
      const options = vendor.selectedCarTypes.map(type => ({
        value: type.id,
        label: type.name,
        data: type,
      }));
      setCarTypeOptions(options);
    }
  }, [vendor?.selectedCarTypes]);

  const addNewCarType = () => {
    // Check if any existing car has empty carName or carType
    const hasEmptyFields = car.some(item => !item.carName.trim() || !item.carType);

    if (hasEmptyFields) {
      // Set error messages for all cars
      const updatedErrors = car.map(item => ({
        carName: !item.carName.trim() ? 'Car Name is required' : '',
        carType: !item.carType ? 'Service Type is required' : '',
      }));
      setCarErrors(updatedErrors);
      return; // Do not add new row
    }

    // If validation passes, add new car row
    setCar([
      ...car,
      {
        carName: '',
        carType: null,
      },
    ]);
    setCarErrors([...carErrors, {}]); // Add empty error object for new row
  };

  const removeCarType = index => {
    const updatedCar = [...car];
    const updatedErrors = [...carErrors];
    updatedCar.splice(index, 1);
    updatedErrors.splice(index, 1);
    setCar(updatedCar);
    setCarErrors(updatedErrors);
  };

  const handleChangeForCar = (index, field, value) => {
    const updatedCar = [...car];
    updatedCar[index][field] = value;
    setCar(updatedCar);

    // Clear error if user fills it
    const updatedErrors: any = [...carErrors];

    if (field === 'carName' && value.trim() !== '') {
      updatedErrors[index].carName = '';
    }
    if (field === 'carType' && value) {
      updatedErrors[index].carType = '';
    }
    setCarErrors(updatedErrors);
  };

  const handleChange = (field, value) => {
    setVendor(prev => ({
      ...prev,
      [field]: value,
    }));
    setErrors(prev => ({
      ...prev,
      [field]: '',
    }));
  };

  const handleCarTypeClick = type => {
    const isSelected = vendor.selectedCarTypes.some(selected => selected.id === type.id);
    const updatedTypes = isSelected ? vendor.selectedCarTypes.filter(t => t.id !== type.id) : [...vendor.selectedCarTypes, type];
    handleChange('selectedCarTypes', updatedTypes);
  };

  const handleAddCarType = data => {
    setCarTypeList(prev => [...prev, data]);
    const existCarTypes = vendor.selectedCarTypes ?? [];
    existCarTypes.push(data);
    handleChange('selectedCarTypes', existCarTypes);
    setIsShowCarTypeModal(false);
  };

  async function loadOptions(search) {
    const response = await axios.get(`${adminAPIURL}/v2/global/regions`, {
      headers: { 'Project-Code': 'ADMIN_ACCESS' },
      params: { search },
      withCredentials: true,
    });

    return {
      options: response?.data?.data?.map(data => ({
        value: data.id,
        label: data.name,
        completeData: data,
      })),
      hasMore: false,
    };
  }

  const onSelectRegion = region => {
    setVendor(prev => ({ ...prev, region }));
  };

  const checkEmailExist = async () => {
    if (!isValidEmail(vendor.email.trim())) {
      setErrors(prev => ({ ...prev, email: 'Email is required' }));
      return;
    }

    if (state?.clientPricing?.vendors?.find(existingVendor => existingVendor?.email === vendor.email.trim())) {
      cogoToast.error('User already exists');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(`${adminAPIURL}/v2/vendor/benefit-type/airport-transfer`, {
        params: { search: vendor.email },
        headers: { 'Project-Code': 'ADMIN_ACCESS' },
        withCredentials: true,
      });
      setLoading(false);
      console.log('Vendor Search Response', res?.data?.vendors);
      if (res?.data?.vendors?.length === 0) {
        setIsEditable(true);
        return;
      } else cogoToast.error('Vendor already exists');
    } catch (error) {
      cogoToast.error(error?.message);
      setLoading(false);
    }
  };

  const handleFileUpload = files => {
    const uploadedFile = files[0];
    if (!uploadedFile) return;

    const allowedExtension = 'pdf';
    const maxFileSize = 10 * 1024 * 1024;

    const fileExtension = uploadedFile.name.split('.').pop().toLowerCase();

    if (fileExtension !== allowedExtension) {
      cogoToast.error(`Invalid file type. Only PDF files are allowed.`);
      return;
    }

    if (uploadedFile.size > maxFileSize) {
      cogoToast.error(`File size exceeds the 10MB limit.`);
      return;
    }

    const formData = new FormData();
    formData.append('file', new File([uploadedFile], uploadedFile.name, { type: uploadedFile.type }));

    dispatch({
      type: POST_IMAGE,
      payload: {
        data: formData,
        urlParam: { fileType: 4 },
      },
    });

    setErrors(prev => ({ ...prev, documentUrl: '' }));
  };

  const triggerUpload = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      {(getCarTypeLoading || loading) && <Loader />}

      {isShowCarTypeModal && <AddCarType onClose={() => setIsShowCarTypeModal(false)} handleAddCarType={handleAddCarType} />}

      <Row className="mb-3">
        {/* Email */}
        <Col md={5} className="mb-2">
          <Label for="email">Email</Label>
          <div className="d-flex gap-2 align-items-center">
            <Input
              type="email"
              id="email"
              value={vendor.email}
              onChange={e => handleChange('email', e.target.value)}
              placeholder="Enter Email"
              invalid={!!errors.email}
              style={{ width: '320px' }}
              disabled={isUpdate}
            />
            <Button style={{ width: '150px' }} color="primary" type="button" disabled={!vendor.email || isUpdate} onClick={checkEmailExist}>
              Check Email
            </Button>
          </div>
          {errors.email && <div className="text-danger small">{errors.email}</div>}
        </Col>

        {/* Name */}
        <Col md={3} className="mb-2">
          <Label for="name">Vendor Name</Label>
          <Input
            type="text"
            id="name"
            value={vendor.name}
            onChange={e => handleChange('name', e.target.value)}
            invalid={!!errors.name}
            disabled={!isEditable}
            placeholder="Vendor Name"
          />
          {errors.name && <div className="text-danger small">{errors.name}</div>}
        </Col>

        {/* Document Upload */}
        {isVendorFullConfigure && (
          <Col md={3} className="mb-2">
            <Label>Upload Document</Label>
            <div onClick={triggerUpload} style={{ cursor: 'pointer' }}>
              <InputGroup
                style={{
                  borderRadius: '5px',
                  overflow: 'hidden',
                  border: `1px solid ${errors?.documentUrl ? '#dc3545' : '#d1d9e6'}`,
                  height: '40px',
                }}
              >
                <Input
                  placeholder={vendor?.documentUrl || 'Upload Document'}
                  disabled
                  style={{
                    backgroundColor: '#f9fafb',
                    color: '#6b7280',
                    border: 'none',
                    pointerEvents: 'none',
                  }}
                  invalid={!!errors.documentUrl}
                />
                <InputGroupText
                  style={{
                    backgroundColor: '#f9f9f9',
                    borderLeft: 'none',
                    pointerEvents: 'none',
                    height: '40px',
                  }}
                >
                  <FiUpload size={18} />
                </InputGroupText>
              </InputGroup>
            </div>
            <input type="file" accept="application/pdf" ref={fileInputRef} onChange={e => handleFileUpload(e.target.files)} hidden />
            {!!errors.documentUrl && <div className="text-danger small">{errors.documentUrl}</div>}
          </Col>
        )}

        {/* Region */}
        <Col md={3} className="mb-2">
          <Label for="region">Region</Label>
          <AsyncPaginate
            debounceTimeout={500}
            value={vendor.region}
            loadOptions={loadOptions}
            onChange={onSelectRegion}
            isMulti={false}
            closeMenuOnSelect
            noOptionsMessage={() => 'No results found'}
            cacheUniqs={[['code']]}
            placeholder=""
            isDisabled={!isEditable}
          />
          {errors.region && <div className="text-danger small">{errors.region}</div>}
        </Col>

        {/* Currency */}
        <Col md={3} className="mb-2">
          <Label for="currency">Currency</Label>
          <Select options={currencyOptions} value={vendor.currency} onChange={e => handleChange('currency', e)} isDisabled={!isEditable} />
          {errors.currency && <div className="text-danger small">{errors.currency}</div>}
        </Col>
      </Row>

      {/* Car Type */}
      {carTypeList.length > 0 && (
        <>
          <Label>Car Type</Label>
          <div className="d-flex flex-wrap gap-2">
            {carTypeList?.map((type, idx) => {
              const isSelected = vendor.selectedCarTypes.some(selected => selected.id === type.id);
              const pillId = `car-type-pill-${idx}`;
              return (
                <React.Fragment key={idx}>
                  <div
                    id={pillId} // <-- add this
                    onClick={() => handleCarTypeClick(type)}
                    className="p-2 cursor-pointer"
                    style={{
                      borderRadius: '25px',
                      color: '#6F7594',
                      border: isSelected ? '1px solid #405189' : '1px solid #D0D2DC',
                      background: isSelected ? '#ABB9E8' : 'transparent',
                    }}
                  >
                    {type?.name?.split(' ')[0] ?? ''}
                  </div>
                  <UncontrolledTooltip placement="top" target={pillId}>
                    {type?.name}
                  </UncontrolledTooltip>
                </React.Fragment>
              );
            })}
          </div>

          {errors.selectedCarTypes && <div className="text-danger small mt-1">{errors.selectedCarTypes}</div>}
        </>
      )}

      {(isVendorFullConfigure || (isUpdate && car.length > 0)) && (
        <Card className="mt-3" style={{ background: 'rgba(246, 246, 246, 1)' }}>
          <CardHeader style={{ background: 'rgba(246, 246, 246, 1)' }}>
            <p className="fs-16 fw-semibold m-0">Car Type Configuration</p>
          </CardHeader>
          <CardBody style={{ maxHeight: '318px', overflowY: 'auto' }}>
            <ul className="list-unstyled m-0 p-0" style={{ minWidth: '800px' }}>
              {car.map((item, index) => (
                <li key={index} className="d-flex align-items-center gap-3 p-2 rounded" style={{ minWidth: 'max-content', whiteSpace: 'nowrap' }}>
                  {/* Car Name */}
                  <div>
                    <Label>Car Name</Label>
                    <Input
                      type="text"
                      value={item.carName}
                      onChange={e => handleChangeForCar(index, 'carName', e.target.value)}
                      placeholder="Car Name"
                    />
                    <div style={{ minHeight: '18px' }}>
                      {carErrors[index]?.carName && <small style={{ color: 'red' }}>{carErrors[index].carName}</small>}
                    </div>
                  </div>

                  {/* Service Type */}
                  <div>
                    <Label>Car Type</Label>
                    <Select
                      options={carTypeOptions}
                      value={item.carType}
                      onChange={selected => handleChangeForCar(index, 'carType', selected)}
                      placeholder="Select"
                      styles={{ container: base => ({ ...base, minWidth: '150px' }) }}
                      isDisabled={isUpdate}
                    />
                    <div style={{ minHeight: '18px' }}>
                      {carErrors[index]?.carType && <small style={{ color: 'red' }}>{carErrors[index].carType}</small>}
                    </div>
                  </div>

                  {/* Passengers */}
                  <div>
                    <Label>No. of Passengers</Label>
                    <Input type="text" value={item?.carType?.data?.numberOfPassengers ?? null} disabled />
                    <div style={{ minHeight: '18px' }}></div>
                  </div>

                  {/* Infant */}
                  <div>
                    <Label>No. of Infant</Label>
                    <Input type="text" value={item?.carType?.data?.numberOfInfants ?? null} disabled />
                    <div style={{ minHeight: '18px' }}></div>
                  </div>

                  {/* Baby Seats */}
                  <div>
                    <Label>No. of Baby Seats</Label>
                    <Input type="text" value={item?.carType?.data?.numberOfBabySeats ?? null} disabled />
                    <div style={{ minHeight: '18px' }}></div>
                  </div>

                  {/* Luggage */}
                  <div>
                    <Label>No. of Luggage</Label>
                    <Input type="text" value={item?.carType?.data?.numberOfLuggages ?? null} disabled />
                    <div style={{ minHeight: '18px' }}></div>
                  </div>

                  {/* Delete Icon */}
                  <div className="d-flex align-items-center">
                    {car.length > 1 && (
                      <Button color="danger" className="mt-1" onClick={() => removeCarType(index)} style={{ padding: '6px 8px' }}>
                        <Trash2 size={18} />
                      </Button>
                    )}
                  </div>
                </li>
              ))}
            </ul>

            {/* Add New Button */}
            <div>
              {!isUpdate && (
                <p style={{ color: 'rgba(64, 81, 137, 1)' }} className="text-decoration-underline text-end cursor-pointer" onClick={addNewCarType}>
                  + Add New
                </p>
              )}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default AddVendor;
